<mat-card [ngClass]="child.TotalActionCount > 0 ? 'actioned' : child.TotalWatchCount > 0 ? 'watchActive' : ''">
	<mat-card-header>
		<mat-card-title>{{child.Name}}</mat-card-title>
	</mat-card-header>

	<mat-card-content class="cardContent" (click)="triggerEvent(child)">

		<img src="{{imagePathSubLocations()}}{{child.Id}}?{{child.Modified}}"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'" alt="Image for {{child.Name}}" />

		@if (child.FunctionalLocation || child.ParentFunctionalLocation) {
		<span class="location" [matTooltip]="child.FunctionalLocation !='' ? child.FunctionalLocation :
			child.ParentFunctionalLocation">FL: {{child.FunctionalLocation !="" ? child.FunctionalLocation :
			child.ParentFunctionalLocation}}</span>
		}

		<span class="description">{{child.Description}}</span>

	</mat-card-content>

	<mat-card-actions class="flex-row">
		<!-- Not Visible from CSS -->
	</mat-card-actions>

	<mat-card-footer>
		<span style="display: flex; justify-content: space-between; width: 100%;">
			<span style="display: flex;">
				<span style="display: flex; margin-right: 1em;"
					[matTooltip]="child.TotalAssetCount + ' Asset' + (child.TotalAssetCount == 1 ? '' : 's') + ' in this location'"
					matTooltipPosition="above">
					<mat-icon>label</mat-icon>{{ child.TotalAssetCount }}
				</span>

				@if (child.TotalWatchCount > 0) {
				<span class="no-wrap-tooltip" style="display: flex; margin-right: 1em;"
					[matTooltip]="child.TotalWatchCount + ' Watched Asset' + (child.TotalWatchCount == 1 ? '' : 's') + ' in this location'"
					matTooltipPosition="above">
					<mat-icon>visibility</mat-icon>{{ child.TotalWatchCount }}
				</span>
				}

				@if (child.TotalActionCount > 0) {
				<span class="no-wrap-tooltip" style="display: flex;"
					[matTooltip]="child.TotalActionCount + ' Actioned Asset' + (child.TotalActionCount == 1 ? '' : 's') + ' in this location'"
					matTooltipPosition="above">
					<mat-icon>content_paste</mat-icon>{{ child.TotalActionCount }}
				</span>
				}
			</span>

			@if (AdminSite) {
			<span class="no-wrap-tooltip app-icon app-icon--edit siteAdmin-only-outline" style="display: flex;"
				matTooltip="Edit {{ child.Name }} Details" matTooltipPosition="above">
				<mat-icon style="color: lightgray;" (click)="editLocation(child)" />
			</span>
			}
		</span>
	</mat-card-footer>
</mat-card>